module.exports = __webpack_public_path__ + "media/img/slider_bcg_right-bef9c9ca.png";